import Vue from 'vue'

export default {
    data() {
        return {
            elementConfig: {
                inviteColleagueShow: window.elemement_Config.inviteColleagueShow,
                frameResourceShow: window.elemement_Config.frameResourceShow,
                orderTrackingStatusShow: window.elemement_Config.orderTrackingStatusShow
            }
        };
    },
    created(){
    }
   
};



// WEBPACK FOOTER //
// ./src/mixins/ElementConfig.js